import React, { useState } from "react";
import vars from "../../vars";

const EditStageForm = ({ stage, stages, onClose, onSave }) => {
    const [title, setTitle] = useState(stage.title);
    const sortedStages = stages ? [...stages].sort((a, b) => a.position - b.position) : [];
    const [position, setPosition] = useState(stage.position);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const body = { title, position };

        try {
            const response = await fetch(`${vars.apiUrl}/stages/${stage.id}`, {
                method: "PUT",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body)
            });
            const data = await response.json();
            if (response.ok && data.success) {
                onSave();
                onClose();
            } else {
                alert(data.message || "שגיאה בעדכון השלב");
            }
        } catch (err) {
            alert("שגיאה בשרת");
        }
    };

    return (
        <form onSubmit={handleSubmit} className="edit-stage-form">
            <label>
                שם שלב:
                <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
            </label>

            <label>
                מיקום:
                <select value={position} onChange={(e) => setPosition(Number(e.target.value))}>
                    {sortedStages.map((s, index) => (
                        <option key={s.id} value={index + 1}>
                            {`מיקום ${index + 1}: ${s.title}`}
                        </option>
                    ))}
                    <option value={sortedStages.length + 1}>
                        בסוף הרשימה (מיקום {sortedStages.length + 1})
                    </option>
                </select>
            </label>

            <div className="popup-buttons">
                <button className="save-btn" type="submit">שמור</button>
                <button className="cancel-btn" type="button" onClick={onClose}>ביטול</button>
            </div>
        </form>
    );
};

export default EditStageForm;